import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Lenis from "lenis";
import "@/i18n";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Portfolio from "@/pages/Portfolio";
import Testimonials from "@/pages/Testimonials";
import Contact from "@/pages/Contact";
import Estimate from "@/pages/Estimate";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import Dashboard from "@/admin/Dashboard";
import Estimates from "@/admin/Estimates";
import EstimateDetail from "@/admin/EstimateDetail";
import Messages from "@/admin/Messages";
import TestimonialsManager from "@/admin/TestimonialsManager";
import PortfolioManager from "@/admin/PortfolioManager";
import { Toaster } from "@/components/ui/sonner";

function Site({ lang }) {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, duration: 1.15 });
    return () => lenis.destroy();
  }, []);

  useEffect(() => {
    i18n.changeLanguage(lang);
    localStorage.setItem("vialfa-lang", lang);
    document.documentElement.lang = lang;
  }, [lang, i18n]);

  useEffect(() => {
    if (lang === "en" && localStorage.getItem("vialfa-lang") === "es") {
      navigate(`/es${location.pathname === "/" ? "" : location.pathname}`, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-offwhite text-navy">
      <Navbar lang={lang} />
      <main>
        <Routes>
          <Route path="/" element={<Home lang={lang} />} />
          <Route path="/services" element={<Services lang={lang} />} />
          <Route path="/about" element={<About lang={lang} />} />
          <Route path="/portfolio" element={<Portfolio lang={lang} />} />
          <Route path="/testimonials" element={<Testimonials lang={lang} />} />
          <Route path="/contact" element={<Contact lang={lang} />} />
          <Route path="/estimate" element={<Estimate lang={lang} />} />
        </Routes>
      </main>
      <Footer lang={lang} />
      <WhatsAppFAB />
      <Toaster position="top-center" richColors />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="estimates" element={<Estimates />} />
          <Route path="estimates/:id" element={<EstimateDetail />} />
          <Route path="messages" element={<Messages />} />
          <Route path="testimonials" element={<TestimonialsManager />} />
          <Route path="portfolio" element={<PortfolioManager />} />
        </Route>
        <Route path="/es/*" element={<Site lang="es" />} />
        <Route path="/*" element={<Site lang="en" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
